import { render } from "./editDialog.vue?vue&type=template&id=47967c53&scoped=true"
import script from "./editDialog.vue?vue&type=script&lang=js"
export * from "./editDialog.vue?vue&type=script&lang=js"

import "./editDialog.vue?vue&type=style&index=0&id=47967c53&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47967c53"]])

export default __exports__